<template>
  <RootPageLayout class="library-page" title="My Library">
    <template #header>
      <LibraryHeader class="library-header__mobile" />
    </template>
    <v-wait for="Error Loading Library">
      <template v-slot:waiting>
        <LoadingError />
      </template>
    </v-wait>
    <v-wait for="Loading Library">
      <template v-slot:waiting>
        <loading-spinner />
      </template>
    </v-wait>
    <LibraryHeader class="library-header__desktop" />
    <div class="layout__wrapper-inner container library-page__container">
      <slot />
    </div>
  </RootPageLayout>
</template>

<script setup lang="ts">
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import RootPageLayout from '@/app/components/RootPageLayout.vue'
import LibraryHeader from './LibraryHeader.vue'
</script>

<style lang="scss" scoped>
.library-page__container {
  padding-top: 0px;
  @media only screen and (max-width: $w-tablet-s) {
    padding-top: 28px;
  }
}

.library-header__desktop {
  margin-bottom: 40px;
  @media only screen and (max-width: $w-tablet-s) {
    display: none;
  }
}

.library-header__mobile {
  display: none;
  background: transparent;
  @include full-width();
  @include hide-horizontal-scrollbar-on-mobile();
  @media only screen and (max-width: $w-tablet-s) {
    display: flex;
  }
}

:deep(.header) {
  @media only screen and (max-width: $w-tablet-s) {
    padding-bottom: 0;
  }
}

:deep(.page-title__title) {
  text-align: center;
}
</style>
